document.addEventListener('DOMContentLoaded', function () {

  function getPromotionSettings() {
    const promotionBlocks = document.querySelectorAll('#promotion-settings .promotion-block');
    const promotions = [];

    promotionBlocks.forEach(block => {
      const collectionHandle = block.getAttribute('data-promotion-collection-handle') || null;
      const productIdAttr    = block.getAttribute('data-promotion-product-id');
      const quantity         = parseInt(block.getAttribute('data-quantity'), 10) || 1;
      const freeProductId    = block.getAttribute('data-free-product-variant-id');

      const productId = productIdAttr ? parseInt(productIdAttr, 10) : null;

      // Tipo de promo:
      // - Si tiene product -> 'product' (PRIORIDAD)
      // - Si no tiene product pero sí collection -> 'collection'
      // - Si no tiene nada, se ignora
      let type = null;
      if (productId) {
        type = 'product';
      } else if (collectionHandle) {
        type = 'collection';
      }

      if (type && freeProductId) {
        promotions.push({
          type,                // 'product' | 'collection'
          collectionHandle,    // puede ser null si type === 'product'
          productId,           // puede ser null si type === 'collection'
          quantity,
          freeProductId
        });
      }
    });

    // Priorizar SIEMPRE las promos por producto
    const productPromos    = promotions.filter(p => p.type === 'product');
    const collectionPromos = promotions.filter(p => p.type === 'collection');

    return [...productPromos, ...collectionPromos];
  }

  async function fetchCollectionProductIds(handle) {
    if (!handle) return [];
    try {
      const response = await fetch(`/collections/${handle}/products.json?limit=250`);
      const data = await response.json();
      return (data.products || []).map(p => p.id);
    } catch (error) {
      console.error(`Error fetching collection ${handle}`, error);
      return [];
    }
  }

  async function applyPromotion() {
    const state = liquidAjaxCart.getCartState();
    const cart  = state && state.cart;

    if (!cart) {
      console.error('Cart state is not available');
      return;
    }

    const cartItems   = cart.items || [];
    const promotions  = getPromotionSettings();

    // 🔹 Detectar todos los ítems de regalo actuales (_free_promotion = true)
    const giftItems = cartItems.filter(item =>
      item.properties && item.properties._free_promotion === "true"
    );

    // 🔹 Buscar la PRIMER promoción que aplique:
    //    - Primero las de producto
    //    - Luego las de colección
    let matchedPromotion = null;

    for (const promotion of promotions) {
      const { type, quantity } = promotion;
      let totalQuantity = 0;

      if (type === 'product' && promotion.productId) {
        const targetProductId = promotion.productId;
        for (const item of cartItems) {
          // Evitar contar el propio regalo
          if (
            item.product_id === targetProductId &&
            (!item.properties || !item.properties._free_promotion)
          ) {
            totalQuantity += item.quantity;
          }
        }
      } else if (type === 'collection' && promotion.collectionHandle) {
        const collectionProductIds = await fetchCollectionProductIds(promotion.collectionHandle);

        for (const item of cartItems) {
          if (
            collectionProductIds.includes(item.product_id) &&
            (!item.properties || !item.properties._free_promotion)
          ) {
            totalQuantity += item.quantity;
          }
        }
      }

      // Si cumple el mínimo, usamos ESTA promo y paramos
      // 🛑 Solo 1 regalo por carrito → no calculamos packs, solo >= quantity
      if (totalQuantity >= quantity) {
        matchedPromotion = promotion;
        break;
      }
    }

    // Si no hay ninguna promo válida → eliminar todos los regalos
    if (!matchedPromotion) {
      if (giftItems.length > 0) {
        for (const g of giftItems) {
          await removeFreeProduct(g.key);
        }
      }
      return;
    }

    // Hay una promo que aplica
    const desiredVariantId = parseInt(matchedPromotion.freeProductId, 10);

    // ▬▬▬ Normalizar regalos existentes ▬▬▬

    const totalGiftQty = giftItems.reduce((sum, item) => sum + (item.quantity || 0), 0);

    // Si ya hay regalos pero con otro variant_id → los borramos todos y agregamos el correcto
    const hasWrongGiftVariant = giftItems.some(item => item.variant_id !== desiredVariantId);

    if (hasWrongGiftVariant) {
      for (const g of giftItems) {
        await removeFreeProduct(g.key);
      }
      await addFreeProduct(desiredVariantId, matchedPromotion);
      return;
    }

    // Ahora: o no hay gifts, o todos son del mismo variant_id
    if (totalGiftQty === 0) {
      // No hay regalo → agregamos 1
      await addFreeProduct(desiredVariantId, matchedPromotion);
      return;
    }

    if (totalGiftQty > 1) {
      // Hay más de 1 regalo → dejamos SOLO 1
      // Tomamos el primero y ajustamos cantidad a 1, el resto los eliminamos
      const [firstGift, ...restGifts] = giftItems;

      await updateFreeProductQuantity(firstGift.key, 1, matchedPromotion);

      for (const g of restGifts) {
        await removeFreeProduct(g.key);
      }
      return;
    }

    // totalGiftQty === 1 y variant correcto → todo bien, no hacemos nada
  }

  // ▬▬▬ Helpers de Ajax Cart ▬▬▬

  function addFreeProduct(freeProductVariantId, promotion) {
    const source = promotion.type === 'product'
      ? `product:${promotion.productId}`
      : `collection:${promotion.collectionHandle || ''}`;

    return liquidAjaxCart.cartRequestAdd({
      items: [{
        id: freeProductVariantId,
        quantity: 1,
        properties: {
          _promotion_source: source,
          _free_promotion: "true"
        }
      }]
    }).then(data => {
      console.log('Free product added:', data);
    }).catch(error => console.error('Error adding free product:', error));
  }

  function updateFreeProductQuantity(lineKey, quantity, promotion) {
    const source = promotion.type === 'product'
      ? `product:${promotion.productId}`
      : `collection:${promotion.collectionHandle || ''}`;

    return liquidAjaxCart.cartRequestChange({
      id: lineKey,
      quantity: quantity,
      properties: {
        _promotion_source: source,
        _free_promotion: "true"
      }
    }).then(data => {
      console.log('Free product quantity updated:', data);
    }).catch(error => console.error('Error updating free product quantity:', error));
  }

  function removeFreeProduct(lineKey) {
    return liquidAjaxCart.cartRequestChange({
      id: lineKey,
      quantity: 0
    }).then(data => {
      console.log('Free product removed:', data);
    }).catch(error => console.error('Error removing free product:', error));
  }

  // ▬▬▬ Listener de cambios de carrito ▬▬▬

  function handleCartUpdate(state, isCartUpdated) {
    if (isCartUpdated) applyPromotion();
  }

  liquidAjaxCart.subscribeToCartStateUpdate(handleCartUpdate);
  applyPromotion();
});
